<template>
  <Modal
    v-model="state"
    title="编辑计划"
    width="502"
    class-name="c-modal vertical-center-modal"
    :mask-closable="false"
    :closable="false"
    @on-visible-change="bindGetData"
  >
    <div class="c-form">
      <ElForm label-width="120px">
        <ElFormItem label="投放计划名称">
          <Tooltip :content="planInfo.planName" transfer max-width="266" placement="top" style="width: 266px">
            <span style="white-space: nowrap">
              {{ planInfo.planName }}
            </span>
          </Tooltip>
        </ElFormItem>

        <ElFormItem label="投放计划ID">
          <span>{{ planInfo.planId }}</span>
        </ElFormItem>

        <ElFormItem label="投放媒体">
          <span>{{ planInfo.mediaName }}</span>
        </ElFormItem>

        <ElFormItem label="投放位">
          <el-select
            v-model="landData.advPositionId"
            placeholder="请选择"
            collapse-tags
            filterable
            clearable
            multiple
            :multiple-limit="10"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in advPositionDataFilterMedia"
              :key="item.id"
              :value="item.id"
              :label="item.name"
              size="small"
            ></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="外投授权">
          <i-Switch v-model="landData.isProxyAuth" :true-value="1" :false-value="0" @on-change="proxyAuthChange" size="small" />
        </ElFormItem>
        <ElFormItem label="选择外投账号" v-if="landData.isProxyAuth === 1">
          <el-select
            v-model="landData.proxyAccountId"
            placeholder="请选择"
            filterable
            clearable
            :popper-append-to-body="false"
            style="width: 200px; overflow: hidden"
          >
            <el-option v-for="item in AGENTS" :key="item.id" :value="item.id" :label="item.name" style="width: 200px"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="API数据回调">
          <i-Switch v-model="landData.callbackSwitch" :true-value="1" :false-value="0" size="small" @on-change="changeCallbackSwitch" />
        </ElFormItem>
        <ElFormItem v-if="landData.callbackSwitch === 1 && callbackTypes.length">
          <CheckboxGroup v-model="landData.callbackSettings">
            <Checkbox label="callbackTypeActive" v-if="callbackTypes.includes(1)" disabled>激活</Checkbox>
            <Checkbox label="callbackTypeRegist" v-if="callbackTypes.includes(2)">注册</Checkbox>
            <Checkbox label="callbackTypeOrder" v-if="callbackTypes.includes(3)">下单</Checkbox>
            <Checkbox label="callbackTypeRecharge" v-if="callbackTypes.includes(4)">付费</Checkbox>
            <Checkbox label="callbackTypeMoney" v-if="callbackTypes.includes(5)">订单金额</Checkbox>
            <Checkbox label="callbackTypeRole" v-if="callbackTypes.includes(6)">创角</Checkbox>
            <Checkbox label="callbackTypeRetain" v-if="callbackTypes.includes(7)">留存</Checkbox>
            <Checkbox label="callbackTypeKeyBehavior" v-if="callbackTypes.includes(8)">关键行为</Checkbox>
          </CheckboxGroup>
        </ElFormItem>
      </ElForm>
    </div>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="closeModal">关闭</Button>
        <Button type="primary" :loading="loading" @click="update">
          <span v-if="loading">保存中...</span>
          <span v-else>确定</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { deepCopy, isEmpty, isArray } from '@/common/js/utils'
import { updateTrackPlan } from '@/api/track.plan.model'
import { initPageData, MEDIA_POSITION, AGENTS } from '@/data/global-opts'
import { mediaCallbackSettingsInfo, callbackKeys } from '../consts/index.js'

const PAGE_REQUIRED_OPTS = initPageData([MEDIA_POSITION, AGENTS])

const landData = {
  isProxyAuth: 0,
  advPositionId: [],
  proxyAccountId: '',
  callbackSwitch: 0,
  callbackSettings: ['callbackTypeActive']
}

export default {
  name: 'planEdit',
  props: {
    value: {
      type: Boolean
    },
    planInfo: {
      type: Object
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    advPositionDataFilterMedia() {
      return this.MEDIA_POSITION.filter((ret) => ret.mediaId === this.planInfo.mediaId)
    },
    callbackTypes() {
      const arr = mediaCallbackSettingsInfo.get(String(this.planInfo.mediaId))
      return isArray(arr) ? arr : []
    }
  },
  methods: {
    bindGetData(e) {
      if (e) {
        this.init()
        return
      }
      this.landData = deepCopy(landData)
    },
    init() {
      const { advertPosiId, proxyAccountId, callbackSwitch, callbackSettings } = this.planInfo
      // 解析广告位
      if (advertPosiId) this.landData.advPositionId = advertPosiId.split(',').map((ret) => Number(ret))
      // 解析外投授权
      if (proxyAccountId) {
        this.landData.isProxyAuth = 1
        this.landData.proxyAccountId = proxyAccountId
      }
      // 解析回调开关
      this.landData.callbackSwitch = callbackSwitch || 0
      if (callbackSwitch && !!callbackSettings) {
        const setting = JSON.parse(callbackSettings)
        for (const key in setting) {
          if (setting[key] === 1) this.landData.callbackSettings.push(key)
        }
      }
    },
    update() {
      const { planId } = this.planInfo
      const { callbackSwitch, proxyAccountId, advPositionId } = this.landData
      if (isEmpty(advPositionId)) {
        this.$Message.warning('投放位至少选择一个！')
        return
      }
      const params = Object.assign({
        planId,
        callbackSwitch,
        proxyAccountId,
        callbackSettings: this.getCallbackSettings(),
        advPositions: advPositionId.join(',')
      })
      this.loading = true
      updateTrackPlan(params).then((data) => {
        this.loading = false
        if (data) {
          this.closeModal()
          this.$Message.success('修改成功')
          this.$emit('on-refresh')
        }
      })
    },
    changeCallbackSwitch(val) {
      if (val) {
        const types = []
        for (const key of this.callbackTypes) {
          types.push(callbackKeys[key - 1])
        }
        this.$set(this.landData, 'callbackSettings', types)
      }
    },
    getCallbackSettings() {
      const { callbackSwitch, callbackSettings } = this.landData
      const updateSetting = {}
      if (callbackSwitch) {
        for (const key of callbackKeys) {
          if (callbackSettings.includes(key)) updateSetting[key] = 1
          else updateSetting[key] = 0
        }
      }
      return JSON.stringify(updateSetting)
    },
    proxyAuthChange(status) {
      if (!status) this.landData.proxyAccountId = ''
    },
    closeModal() {
      this.$emit('input', false)
    }
  },
  data() {
    return {
      loading: false,
      landData: deepCopy(landData)
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.c-form {
  ::v-deep .el-form-item {
    margin-bottom: 4px;
  }
}
</style>
